import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class OrgInviteRejected extends BaseAction {
    public static userVisible:boolean = false;
    public static getTitle:Function = () => Locale.gettext('Org Invitation Rejected');
    public static getDescription:Function = () => Locale.gettext('A user rejected your request to join your organization');
    public static supportedRoutes:string[] = [ "push", "email" ];
}